export default __webpack_public_path__ + "static/media/deposit-qrcode-step3-option2.8c4f9ff0.png";